var _path, _path2, _line, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineBetweenPlanes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 14,
    viewBox: "0 0 74 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50507 12.664C10.7708 12.664 13.4696 10.0869 13.4696 6.84555C13.4696 3.60416 10.7708 1.0271 7.50507 1.0271C4.23931 1.0271 1.54053 3.60416 1.54053 6.84555C1.54053 10.0869 4.23931 12.664 7.50507 12.664Z",
    stroke: "#E53238",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3703 12.664C69.6361 12.664 72.3348 10.0869 72.3348 6.84555C72.3348 3.60416 69.6361 1.0271 66.3703 1.0271C63.1045 1.0271 60.4058 3.60416 60.4058 6.84555C60.4058 10.0869 63.1045 12.664 66.3703 12.664Z",
    stroke: "#86B817",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.4695,
    y1: 6.53394,
    x2: 60.4057,
    y2: 6.53394,
    stroke: "url(#paint0_linear_474_15883)",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_474_15883",
    x1: 13.1787,
    y1: 8.03392,
    x2: 61.4069,
    y2: 7.78242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E53238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86B817"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBetweenPlanes);
export default __webpack_public_path__ + "static/media/line_between_planes.b6c18387567de388b0fbfc47097922f3.svg";
export { ForwardRef as ReactComponent };